import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route, Switch } from 'react-router'
import { NotFound } from 'secondstep-components'
import K8Tier2LessonCompletion from 'pages/K8Tier2LessonCompletion'
import LearnErrorBoundary from 'components/LearnErrorBoundary'
import validRoutesMap from './validRoutesMap'

export const InterventionsRouter = ({ lastViewedGradeBand = 'k-2', match }) => {
  const checkIsValidRoute = routeProps => {
    const gradeBand = routeProps.match.params.gradeBand
    return validRoutesMap[gradeBand] ? (
      <K8Tier2LessonCompletion {...routeProps} />
    ) : (
      <NotFound location={routeProps.location} />
    )
  }
  return (
    <LearnErrorBoundary>
      <Switch>
        <Route path={`${match.path}/:gradeBand`} render={checkIsValidRoute} />
        <Redirect
          exact
          from={`${match.path}`}
          to={`${match.path}/${lastViewedGradeBand}`}
        />
        <Route component={NotFound} />
      </Switch>
    </LearnErrorBoundary>
  )
}

InterventionsRouter.propTypes = {
  lastViewedGradeBand: PropTypes.string,
  match: PropTypes.object,
}

export default InterventionsRouter
